exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".worklflowContainer-78a70{margin:25px}.errorMessage-f2cf6{margin-right:10px;color:tomato}", ""]);

// Exports
exports.locals = {
	"worklflowContainer": "worklflowContainer-78a70",
	"errorMessage": "errorMessage-f2cf6"
};